<!--礼包详情-->
<template>
  <basic-container>
    <el-page-header @back="$router.go(-1)" content="批次详情" />
    <div class="ac_tabs">
      <div class="ac_tabs-contain">
        <el-descriptions :column="4" size="small" border>
          <el-descriptions-item label="批次名称">{{ info.batchName }}</el-descriptions-item>
          <el-descriptions-item label="批次Id">{{ info.batchId }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ info.status }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ info.userName }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ info.creatTime }}</el-descriptions-item>
          <el-descriptions-item label="所属公司">{{ info.company }}</el-descriptions-item>
          <el-descriptions-item label="有效期">{{ info.validDate }}</el-descriptions-item>
          <el-descriptions-item label="用途">{{ info.use }}</el-descriptions-item>
          <el-descriptions-item label="批次总金额">{{ info.totalAmount }}</el-descriptions-item>
          <el-descriptions-item label="已绑定金额">{{ info.bindAmount }}</el-descriptions-item>
          <el-descriptions-item label="已发放金额">{{ info.issueAmount }}</el-descriptions-item>
          <el-descriptions-item label="已核销金额">{{ info.verAmount }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <div class="ac_tabs">
      <div class="ac_tabs_nav-wrap">
        <div class="ac_tabs-items">
          <span>礼包</span>
          <span style="padding-left: 20px">
            <el-button
              type="success"
              size="mini"
              v-if="info.status !== '已作废'"
              v-has-permi="['coupon_gift_add']"
              icon="el-icon-plus"
              @click="handleCouponPkgCreate"
              >新增礼包</el-button
            >
          </span>
        </div>
      </div>
      <div class="ac_tabs-contain">
        <yd-table
          :loading="loading"
          :data="data"
          size="mini"
          border
          max-height="320"
          :pagination="page"
          @onChange="onTableChange"
        >
          <el-table-column label="礼包ID" width="150" prop="giftBagId" align="center" />
          <el-table-column label="礼包名称" prop="giftBagName" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.stop="handlePkgView(scope.row.giftBagId)">{{
                scope.row.giftBagName
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="金额/个" prop="amount" align="center" />
          <el-table-column label="已绑定金额" prop="bindAmount" width="100" align="center" />
          <el-table-column label="礼包数量" prop="giftBagNum" align="center" />
          <el-table-column label="剩余" prop="remainGiftBagNum" align="center" />
          <el-table-column label="券组成" prop="coupon" align="center" />
          <el-table-column label="创建人" prop="userName" align="center" />
          <el-table-column label="创建时间" prop="creatTime" width="180" align="center" />
          <el-table-column label="状态" prop="giftBagStatus" align="center" />
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-has-permi="['coupon_gift_delete']"
                @click="handleZuofeipici(scope.row.giftBagId)"
                v-if="scope.row.stateCode !== 2"
                >作废</el-button
              >
            </template>
          </el-table-column>
        </yd-table>
      </div>
    </div>
    <!--新增礼包-->
    <YdDialog title="新增礼包" :visible.sync="visible" width="50%" :append-to-body="true">
      <el-form ref="form" :model="form" :rules="rules" size="small" label-width="150px">
        <el-form-item label="礼包名称：" prop="giftName">
          <el-input
            v-model="form.giftName"
            placeholder="请输入礼包名称"
            clearable
            maxlength="20"
            show-word-limit
          />
          <span>
            内部优惠券是否可拆分
            <avue-switch
              v-model="form.split"
              :dic="[{ value: 2 }, { value: 1 }]"
              @change="switchChange"
            />
          </span>
          <div class="tipsBox">
            <!-- <img style="width: 20px; height: 20px" src="./static/tips.png"></img> -->
            <div>提示：</div>
            <div>
              <span>发放优惠券：按钮开启、礼包可拆分！</span><br />
              <span>发放礼包：按钮关闭、礼包不可拆分</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="创建数量：" prop="giftNum">
          <avue-input-number v-model="form.giftNum" :disabled="form.split === 1" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="reset">取 消</el-button>
        <el-button type="primary" size="small" :loading="pkgLoading" @click="submit"
          >保 存</el-button
        >
      </div>
    </YdDialog>
  </basic-container>
</template>

<script>
  import {
    pkgCreate,
    getPkgDetails,
    listGiftPageByBatchId,
    zuofeilibao
  } from '@/api/marketing/coupon-api'
  export default {
    name: 'couponPkg',
    data() {
      return {
        loading: true,
        visible: false,
        info: {},
        form: {
          split: 1,
          giftName: '',
          giftNum: undefined
        },
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        data: [],
        rules: {
          giftName: [{ required: true, message: '请输入礼包名称', trigger: 'blur' }],
          giftNum: [{ required: true, message: '请输入创建数量', trigger: 'blur' }]
        },
        pkgLoading: false
      }
    },
    created() {
      this.info.batchId = this.$route.query.pkgId
      this.getDetails()
      // this.onLoad()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.page.current = current
        this.page.size = pageSize
        this.onLoad()
      },
      handlePkgView(id) {
        this.$router.push({
          path: '/couponDetails',
          query: { cpId: id, batchId: this.info.batchId }
        })
      },
      handleCouponPkgCreate() {
        this.visible = true
        this.switchChange()
      },
      async getDetails() {
        await getPkgDetails(this.info.batchId).then((resp) => {
          this.info = resp.data
        })
      },
      async onLoad() {
        this.loading = true
        const adonData = {
          batchId: this.info.batchId,
          current: this.page.current,
          size: this.page.size
        }
        await listGiftPageByBatchId(adonData).then((resp) => {
          this.data = resp.data.records || []
          this.loading = false
          this.page.total = resp.data.total
        })
      },
      reset() {
        this.$refs.form.resetFields()
        this.visible = false
      },
      submit() {
        this.$refs.form.validate((valid) => {
          if (!valid) return
          this.form.batchId = this.info.batchId
          this.pkgLoading = true
          pkgCreate(this.form)
            .then((resp) => {
              if (resp.code !== 0) return
              this.$message.success('操作成功')
              this.visible = false
              this.onLoad()
              this.reset()
            })
            .finally(() => {
              this.pkgLoading = false
            })
        })
      },
      handleZuofeipici(id) {
        this.$confirm('确定将该礼包作废吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            return zuofeilibao(id)
          })
          .then(() => {
            this.onLoad()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          })
      },
      switchChange() {
        if (this.form.split === 1) {
          this.form.giftNum = 1
        } else {
          this.form.giftNum = undefined
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    // align-items: center;
    margin: 0 0 10px 0;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }

  .ac_tabs {
    padding: 10px 10px;
    box-sizing: border-box;
  }
  .ac_tabs_nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
  }
  .ac_tabs_nav-wrap:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #e4e7ed;
    z-index: 1;
  }
  .ac_tabs-items {
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    position: relative;
  }
  .ac_tabs-contain {
    padding: 10px 0 0 0;
  }
</style>
